/* eslint-disable no-magic-numbers */
import React from 'react';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage, useIntl } from '@futrli/localisation';

interface Props {
  isOpenForecastingDialog?: boolean;
  handleCloseDialog: () => void;
  onSubmit: () => void;
}

export const ClosingForecastDialog = ({ isOpenForecastingDialog, handleCloseDialog, onSubmit }: Props) => {
  const intl = useIntl();

  return (
    <Dialog
      title={intl.formatMessage({
        id: 'predict.warning_closing_budget',
        defaultMessage: 'Warning: you are closing this budget'
      })}
      onCancel={handleCloseDialog}
      open={!!isOpenForecastingDialog}
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={handleCloseDialog}>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button buttonType="primary" onClick={onSubmit}>
            <FormattedMessage id="predict.close_this_budget" defaultMessage="Close this budget" />
          </Button>
        }
        onSubmit={onSubmit}
      >
        <Typography fontSize="16px" mb={0}>
          <FormattedMessage
            id="predict.prevent_budget_editing"
            defaultMessage="This prevents the budget from further editing and is irreversible."
          />
        </Typography>
      </Form>
    </Dialog>
  );
};
